import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import { getSeverity } from "../../utils/getSeverity";
import ScoreMeter from "src/shared/components/ScoreMeter";
import { useGetPatientScoresQuery } from "src/api/services/mentalHealthApi";

interface Props {
  onNavigate: () => void;
}

const Phq9Card = ({ onNavigate }: Props) => {
  const { t } = useTranslation();
  const component = "amh-review";
  const { data = { phq9: 0 } } = useGetPatientScoresQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const phq9SeverityLabel = useMemo(() => {
    const label = getSeverity("PHQ-9", data.phq9);
    if (label == null) return null;

    return `${t(`${component}.label.${label.toLowerCase()}`, label)} ${t(
      `${component}.depression`,
      "Depression"
    )}`;
  }, [data.phq9, t]);

  return (
    <WhiteCard
      sx={{
        borderRadius: "30px",
        background: `linear-gradient(
        180deg,
        #79D2E8 0.31%,
        rgba(255, 255, 255, 0.36) 99.69%
      ),
      #79D2E8`,
        padding: "40px 40px 20px 40px",
      }}
      gap={12}
      onClick={onNavigate}
    >
      <Typography color="#ffffff" variant="h4">
        {phq9SeverityLabel}
      </Typography>
      <Stack gap={5}>
        <ScoreMeter score={data.phq9} threshold={[0, 6, 13, 20, 27]} />
        <Typography variant="body2" color="#ffffff" textAlign={"center"}>
          {t(`${component}.phq-9.disclaimer`, "Measured by the PHQ-9")}
        </Typography>
      </Stack>
    </WhiteCard>
  );
};

export default Phq9Card;
